<template>
  <b-container fluid>
    <b-row>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        {{ testSelected ? testSelected.name: null }}
      </b-col>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
          }"
          @click="$emit('back', 'testType')"
        >
          ย้อนกลับ
        </b-button>
      </b-col>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
            'active': tabSelectedComputed === 'editTest'
          }"
          @click="$emit('input', 'editTest')"
        >
          ข้อมูลทั่วไป
        </b-button>
      </b-col>
      <template v-if="testSelected.has_sub_tests || testSelected.has_sub_test || testSelected.sub_test.length > 0">
        <b-col
          cols="auto"
          :class="{
            'col-left': true,
            'my-auto': true,
          }"
        >
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'subTest'
            }"
            @click="$emit('input', 'subTest')"
          >
            ผลตรวจย่อย
          </b-button>
        </b-col>
        <!--        <b-col-->
        <!--          cols="auto"-->
        <!--          :class="{-->
        <!--            'col-left': true,-->
        <!--            'my-auto': true,-->
        <!--          }"-->
        <!--        >-->
        <!--          <b-button-->
        <!--            size="sm"-->
        <!--            :class="{-->
        <!--              'tab-button': true,-->
        <!--              'active': tabSelectedComputed === 'createSubTest'-->
        <!--            }"-->
        <!--            @click="$emit('input', 'createSubTest')"-->
        <!--          >-->
        <!--            สร้างผลตรวจย่อยใน {{ testSelected ? testSelected.name: null }}-->
        <!--          </b-button>-->
        <!--        </b-col>-->
      </template>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
            'active': tabSelectedComputed === 'priceGroup'
          }"
          @click="$emit('input', 'priceGroup')"
        >
          ราคา
        </b-button>
      </b-col>
      <b-col
        cols="auto"
        :class="{
          'col-left': true,
          'my-auto': true,
        }"
      >
        <b-button
          size="sm"
          :class="{
            'tab-button': true,
            'active': tabSelectedComputed === 'testRefRange'
          }"
          @click="$emit('input', 'testRefRange')"
        >
          Ref Range
        </b-button>
      </b-col>
      <!--      <b-col>-->
      <!--        <b-row align-h="end">-->
      <!--          <template v-if="sequenceChange">-->
      <!--            <template v-if="tabSelectedComputed === 'subTest'">-->
      <!--              <b-col-->
      <!--                cols="auto"-->
      <!--              >-->
      <!--                <b-button-->
      <!--                  size="sm"-->
      <!--                  variant="success"-->
      <!--                  @click="updateSubTestsSequenceHandler"-->
      <!--                >-->
      <!--                  บันทึกลำดับ-->
      <!--                </b-button>-->
      <!--              </b-col>-->
      <!--              <b-col-->
      <!--                cols="auto"-->
      <!--              >-->
      <!--                <b-button-->
      <!--                  size="sm"-->
      <!--                  variant="danger"-->
      <!--                  @click="resetSubTestsSequenceHandler"-->
      <!--                >-->
      <!--                  รีเซ็ตลำดับ-->
      <!--                </b-button>-->
      <!--              </b-col>-->
      <!--            </template>-->
      <!--          </template>-->
      <!--        </b-row>-->
      <!--      </b-col>-->
    </b-row>
    <template v-if="tabSelectedComputed === 'subTest'">
      <b-row class="pt-3 mt-3 sub-panel">
        <b-col
          cols="auto"
          :class="{
            'col-left': true,
            'my-auto': true,
          }"
        >
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'createSubTest'
            }"
            @click="$emit('input', 'createSubTest')"
          >
            สร้างผลตรวจย่อยใน {{ testSelected ? testSelected.name: null }}
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-row align-h="end">
            <template v-if="sequenceChange">
              <template v-if="tabSelectedComputed === 'subTest'">
                <b-col
                  cols="auto"
                >
                  <b-button
                    size="sm"
                    variant="success"
                    @click="updateSubTestsSequenceHandler"
                  >
                    บันทึกลำดับ
                  </b-button>
                </b-col>
                <b-col
                  cols="auto"
                >
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="resetSubTestsSequenceHandler"
                  >
                    รีเซ็ตลำดับ
                  </b-button>
                </b-col>
              </template>
            </template>
          </b-row>
        </b-col>
      </b-row>
    </template>
    <template v-if="tabSelectedComputed === 'testRefRange' || tabSelectedComputed === 'refRangeMultiCreate'">
      <b-row class="pt-3 mt-3 sub-panel">
        <b-col cols="auto">
          <b-button
            size="sm"
            variant="success"
            @click="updateRefRangeHandler"
          >
            บันทึก
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            size="sm"
            :class="{
              'tab-button': true,
              'active': tabSelectedComputed === 'refRangeMultiCreate'
            }"
            @click="$emit('input', 'refRangeMultiCreate')"
          >
            เพิ่มค่า Ref Range
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-container>
</template>

<script>
  export default {
    name: "TestLevelTitle",
    props: {
      sequenceChange: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: 'editTest'
      },
      testSelected: {
        type: Object,
        default: () => null,
      }
    },
    computed: {
      tabSelectedComputed: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      async resetSubTestsSequenceHandler() {
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการรีเซ็ตลำดับ',
          text: "คุณต้องการรีเซ็ตลำดับผลตรวจย่อยที่ได้เปลี่ยนแปลงไปใช่หรือไม่?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'รีเซ็ต',
          cancelButtonText: 'ยกเลิก',
        })

        if (confirm.value) {
          this.$emit('reset-sub-test-sequence')
        }
      },
      async updateSubTestsSequenceHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('update-sub-test-sequence', password)
        } else {
          return
        }

      },
      async updateRefRangeHandler() {
        const { value: password } = await this.$swal.fire({
          title: 'กรอกรหัสผ่านเพื่อดำเนินการต่อไป',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off',
            autocorrect: 'off'
          }
        })

        if (password) {
          this.$emit('update-ref-range', password)
        } else {
          return
        }

      }
    }
  }
</script>

<style lang="scss" scoped>
  .action-panel {
    opacity: 0;
    &.visible {
      opacity: 100%;
    }
  }

  .tab-button {
    &.active {
      background: #2E83D9 !important;
      color: white;
    }
  }

  .test-sequence-panel {
    border-top: 1px solid black;
  }

  .sub-panel {
    border-top: 1px solid black;
  }
</style>